const verifiedFilterYear = (filterOptions, location) => {
  const incomingYear = new URLSearchParams(location).get('year');

  if (filterOptions.includes(incomingYear)) return incomingYear;
  return filterOptions[0];
};

export default verifiedFilterYear;
